import { FETCHING_FINANCIALSERVICES, FETCH_FINANCIALSERVICES } from './financialServicesContainerActions'

export default function (state = { loading: false, financialServices: [] }, action) {
  switch (action.type) {
    case FETCH_FINANCIALSERVICES:
      // Deep clone the array to prevent mutations
      return { 
        loading: false, 
        financialServices: (action.payload || []).map(item => ({ ...item }))
      }
    case FETCHING_FINANCIALSERVICES:
      return { loading: true, financialServices: [] }
  }
  return state
}
